import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// PATCH 40 — client access to the ONE canonical glossary (backend single source of truth). Cached so
// every Before/During/After surface renders identical wording, never a fresh paraphrase.
let _cache = null;
let _pending = null;

export async function loadGlossary() {
  if (_cache) return _cache;
  if (!_pending) {
    _pending = api.get("/coach/beco/glossary")
      .then((r) => { _cache = r.data; return _cache; })
      .catch(() => ({ metrics: [], feature_map: {} }));
  }
  return _pending;
}

export function useGlossary() {
  const [g, setG] = useState(_cache);
  useEffect(() => { let on = true; loadGlossary().then((x) => { if (on) setG(x); }); return () => { on = false; }; }, []);
  return g;
}

export function biasForKey(glossary, key) {
  if (!glossary || !key) return null;
  return (glossary.metrics || []).find((m) => m.key === key) || null;
}

export function biasForFeature(glossary, featureId) {
  if (!glossary || !featureId) return null;
  return biasForKey(glossary, glossary.feature_map?.[featureId]);
}

// PATCH — fire-and-forget live telemetry into the Nudge Transparency Ledger, so BeCo sub-metrics move
// off cold-start as real builds happen. Never blocks the UI; failures are silent.
export function logBecoTelemetry(payload) {
  try { api.post("/coach/beco/telemetry", payload).catch(() => {}); } catch { /* ignore */ }
}
